import React from 'react';
import Loading from './Loading';
import Table from './Table';

const RecentLostRecords = ({entries}) => {
  if (entries === null) return <Loading />;

  return (
    <div style={{width: 'calc(100% - 40px)',
                 overflowY: 'auto',
                 padding: '20px',
                 display: 'flex',
                 flexDirection: 'column',
                 gap: '20px',
                }}>
      <Table headers={['Date', 'Time', 'Domain', 'Reason']}
             contents={entries.map(({ date, time, domain, reason }) => {
               return [date, time, domain, reason];
             })}
             proportions={[1, 1, 1, 2]} />

    </div>
  );
}

export default RecentLostRecords;
